import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import {
  doGetAllCompanies,
  doCreateCompany,
  doUpdateCompany,
  doGetAllPartnerCompanies,
  doCreatePartnerCompany,
  doUpdatePartnerCompany,
} from "./thunk";

const companiesAdapter = createEntityAdapter({
  selectId: item => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const companySlice = createSlice({
  name: "company",
  initialState: {
    isFetching: false,
    metadata: {},
    entities: [],
    ids: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetAllCompanies.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doGetAllCompanies.fulfilled, (state, action) => {
      const { companies, meta } = action.payload;
      state.isFetching = false;
      state.metadata = meta;
      companiesAdapter.setAll(state, companies);
    });
    builder.addCase(doGetAllCompanies.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doCreateCompany.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doCreateCompany.fulfilled, (state, action) => {
      state.isFetching = false;
      companiesAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doCreateCompany.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doUpdateCompany.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doUpdateCompany.fulfilled, (state, action) => {
      state.isFetching = false;
      companiesAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdateCompany.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doGetAllPartnerCompanies.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doGetAllPartnerCompanies.fulfilled, (state, action) => {
      const { companies, meta } = action.payload;
      state.isFetching = false;
      state.metadata = meta;
      companiesAdapter.setAll(state, companies);
    });
    builder.addCase(doGetAllPartnerCompanies.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doCreatePartnerCompany.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doCreatePartnerCompany.fulfilled, (state, action) => {
      state.isFetching = false;
      companiesAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doCreatePartnerCompany.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doUpdatePartnerCompany.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doUpdatePartnerCompany.fulfilled, (state, action) => {
      state.isFetching = false;
      companiesAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdatePartnerCompany.rejected, state => {
      state.isFetching = false;
    });
  },
});

export const {
  selectAll: selectAllCompanies,
  selectById: selectCompanyById,
  selectIds: selectCompanyIds,
} = companiesAdapter.getSelectors(state => state.company);

const { reducer: companyReducer } = companySlice;
export default companyReducer;
